import { useEffect, useContext } from "react";
import { GlobalContext } from "../providers/GlobalProvider";

const useTitle = () => {
  const { title, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    window.document.title = title;

    return () => (window.document.title = "Code Red");
  }, [title]);

  return { title, setTitle };
};

export default useTitle;
